import {
  grayColor,
  container,
  title,
  main,
  mainRaised,
  section,
  cardTitle,
  mrAuto,
  mlAuto,
} from '../../../coscef';

import imagesStyles from '../../imagesStyles';
import tooltipsStyle from '../../tooltipsStyle';

const sectionDetailsStyle = {
  ...tooltipsStyle,
  mrAuto,
  mlAuto,
  main: {
    ...main,
    ...mainRaised,
  },
  container: {
    ...container,
    zIndex: '2',
  },
  title: {
    ...title,
    marginBottom: '25px',
  },
  section: {
    paddingBottom: '0',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    padding: '70px 0',
    '& p': {
      fontSize: '1.188rem',
      lineHeight: '1.5em',
      color: grayColor[15],
      marginBottom: '30px',
    },
  },
  quoteText: {
    fontSize: '1.5rem !important',
  },
  ...imagesStyles,
  sectionfinal: {
    ...section,
    padding: '70px 0px',
    textAlign: 'center',
  },
  blogTags: {
    marginTop: '8px',
  },
  cardTitle,
  description: {
    fontSize: '1rem',
    color: grayColor[0],
  },
  titleComment: {
    ...title,
    marginBottom: '30px',
    textAlign: 'center',
  },
  textArea: {
    marginRight: '15px',
    marginLeft: '15px',
  },
  left: {
    float: 'left!important',
    display: 'block',
  },
  right: {
    padding: '15px 0',
    margin: '0',
    float: 'right',
  },
  floatRight: {
    float: 'right!important',
    marginBottom: '40px',
  },
  color555: {
    '&,& *': {
      color: grayColor[15] + ' !important',
    },
  },
  footerButtons: {
    float: 'right',
  },
  footerIcons: {
    width: '1.1rem',
    height: '1.1rem',
    position: 'relative',
    display: 'inline-block',
    top: '0',
    marginTop: '-1em',
    marginBottom: '-1em',
    marginRight: '3px',
    verticalAlign: 'middle',
  },
  moveTo: {
    marginTop: '80px',
  },
};

export default sectionDetailsStyle;
